import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { NavigationService } from '../navigation.service';
import { CursorService } from '../cursor.service';
import { BreakpointsService } from '../breakpoints.service';
import { Router } from '@angular/router';
import * as imagesLoaded from 'imagesloaded';
import * as penner from '../penner.easing';;
import { forEach, clone, range, isEqual, find } from 'lodash';
enum Direction {x, y}

@Component({
  selector: 'app-poster',
  templateUrl: './poster.component.html',
  styleUrls: ['./poster.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)',
    '(mousedown)': 'onMousedown($event)',
    '(mouseup)': 'onMouseup($event)',
    '(panstart)': 'onPanStart($event)',
    '(panend)': 'onPanEnd($event)',
    '(panmove)': 'onPanMove($event)',
    '(pancancel)': 'onPanCancel($event)',
    '(mousemove)': 'onMouseMove($event)',
    '(mouseout)': 'onMouseOut($event)',
    '(mouseleave)': 'onMouseLeave($event)'
  }
})
export class PosterComponent implements OnInit {
  el: Element;
  @Input() items: any[];
  @Input() startPosition: any;
  @Input() poster: any;
  timeCoefficient: number = 3.5;
  loadingBuffer: number = 600;
  isPanning: boolean = false;
  position: any;
  isWiggling: boolean = false;
  scale: number = 0.75;

  posterColRange: number[];
  posterRowRange: number[];

  wiggleTimer;
  wiggleAnimationFrame;
  wiggleStartPosition: any;
  direction: any = null;
  isMoving: any = {
      x: false,
      y: false
    };
  movePosterAnimationFrame: any = {
      x: null,
      y: null
    };
  moveEasingPosterStartTime: any = {
      x: null,
      y: null
    };
  moveEasingPosterStartPosition: any = {
      x: null,
      y: null
    };
  moveLinearPosterStartTime: any = {
      x: null,
      y: null
    };
  moveLinearPosterStartPosition: any = {
      x: null,
      y: null
    };
  moveDirection: any = {
      x: null,
      y: null
    };

  panInertiaTimer: number;
  panInertiaStartPosition: any;
  panInertiaAnimationFrame: any;
  breakpointSubscription: any;

  clickStartPosition: any = {
    x: 0,
    y: 0
  };
  clickPositionDelta: any = {
    x: 0,
    y: 0
  };

  delta = {
    x: 0,
    y: 0
  };

  loadedItems: any = [];

  constructor(
    private router: Router,
    private NavigationService: NavigationService,
    private CursorService: CursorService,
    private BreakpointsService: BreakpointsService,
    el: ElementRef
  ) {
    this.el = el.nativeElement;
  }

  ngOnInit() {
    this.position = this.startPosition;

    forEach(this.items, (item) => {
      let url = '';
      let queryParams = {};
      if (typeof item.link_url !== 'undefined' && item.link_url !== '') {
        url = item.link_url;
        item.isExternal = true;
      } else if (typeof item.link_page_id !== 'undefined' && item.link_page_id !== 0) {
        url = this.getPageUrl(item.link_page_id);
        queryParams['id'] = item.link_page_id;
        item.isExternal = false;
      }
      item.url = url;
      item.queryParams = queryParams;
    });

    setTimeout(() => {
      this.loadImages();
      imagesLoaded(this.el, ( instance, image ) => {
        setTimeout(() => {
          if (!this.isMoving.x && !this.isMoving.y) {
            this.startWiggle();
          }
        }, 600);
      });
    });

    this.breakpointSubscription = this.BreakpointsService.sizeObs.subscribe((size) => {
      this.scale = size === 'xs' || size === 'sm' ? 0.5 : 0.75;
    });
  }

  getPageUrl(pageId) {
    let url = '';
    if (pageId !== 0) {
      url = `/page`;
    }
    return url;
  }

  wiggleAnimation(distance, duration) {
    let time = Date.now() - this.wiggleTimer,
      position = {
        top: penner.easeOutCirc(time, this.wiggleStartPosition.top, distance.y, duration),
        left: penner.easeOutCirc(time, this.wiggleStartPosition.left, distance.x, duration)
      };

    if (time > duration) {
      this.stopWiggle();
      return;
    }

    this.position.top = position.top;
    this.position.left = position.left;

    this.loadImages();

    this.wiggleAnimationFrame = window.requestAnimationFrame(this.wiggleAnimation.bind(this, distance, duration));
  }

  startWiggle() {
    let distance = {
      x: -75,
      y: -75
    };
    let duration = 2000;
    this.CursorService.cursor = 'move';
    this.isWiggling = true;
    this.wiggleStartPosition = clone(this.position);
    this.wiggleTimer = Date.now();
    this.wiggleAnimationFrame = requestAnimationFrame(this.wiggleAnimation.bind(this, distance, duration));
  }

  stopWiggle() {
    cancelAnimationFrame(this.wiggleAnimationFrame);
    this.isWiggling = false;
  }

  onMouseOut($event) {
    if (!$event.relatedTarget && !$event.toElement) {
      this.stopMovingPoster();
    }
  }

  mod(n, m) {
    return ((n % m) + m) % m;
  }

  loadImages() {
    // Calculate which posters will cover the screen,
    // including loading buffer
    let posterColStart = Math.floor((-this.position.left - this.loadingBuffer)/this.poster.width);
    let posterColEnd = Math.floor((-this.position.left + window.innerWidth + this.loadingBuffer) / this.poster.width);

    let posterRowStart = Math.floor((-this.position.top - this.loadingBuffer)/this.poster.height);
    let posterRowEnd = Math.floor((-this.position.top + window.innerHeight + this.loadingBuffer) / this.poster.height);

    let posterColRange = range(posterColStart, posterColEnd + 1);
    let posterRowRange = range(posterRowStart, posterRowEnd + 1);

    // If poster range to cover screen has changed,
    // load more posters
    if (!isEqual(posterColRange, this.posterColRange) || !isEqual(posterRowRange,this.posterRowRange)) {
      let loadedItems = [];

      forEach(posterColRange, (column) => {
        forEach(posterRowRange, (row) => {
          forEach(this.items, (item, i) => {
            let offsetX = this.poster.width * column + item.x;
            let offsetY = this.poster.height * row + item.y;
            loadedItems.push({
              width: item.width,
              height: item.height,
              image: item.image,
              url: item.url,
              queryParams: item.queryParams,
              isExternal: item.isExternal,
              id: `${item.id}-col${column}-row${row}`,
              itemId: item.id,
              isInitialised: typeof item.isInitialised !== 'undefined' ? item.isInitialised : false,
              offsetX: offsetX,
              offsetY: offsetY,
              index: i,
              show: false
            });
          });
        });
      });

      this.loadedItems = loadedItems;

      this.posterColRange = posterColRange;
      this.posterRowRange = posterRowRange;
    }

    let viewX1 = -this.position.left * this.scale;
    let viewX2 = window.innerWidth - (this.position.left * this.scale);
    let viewY1 = -this.position.top * this.scale;
    let viewY2 = window.innerHeight - (this.position.top * this.scale);
    let buffer = this.loadingBuffer * this.scale;

    forEach(this.loadedItems, (image) => {
      let imageX1 = image.offsetX * this.scale;
      let imageX2 = (image.offsetX + image.width) * this.scale;
      let imageY1 = image.offsetY * this.scale;
      let imageY2 = (image.offsetY + image.height) * this.scale;
      
      if (imageX1 > viewX2 || imageX2 < viewX1 || imageY1 > viewY2 || imageY2 < viewY1) {
      // if (imageX1 > viewX2 + buffer || imageX2 < viewX1 - buffer || imageY1 > viewY2 + buffer || imageY2 < viewY1 - buffer) {
        image.show = false;
      } else {
        image.show = true;
      }
    });
  }

  trackItem(index, item) {
    return item ? item.id : undefined;
  }

  onImageInitEvent(itemId) {
    let item = find(this.items, { id: itemId });
    item.isInitialised = true;
  }

  onResize($event) {
    this.loadImages();
  }

  onMousedown($event) {
    this.clickStartPosition = { x: $event.pageX, y: $event.pageY };
    this.isPanning = true;
    this.CursorService.cursor = 'grabbing';

    cancelAnimationFrame(this.panInertiaAnimationFrame);
    this.stopWiggle();
    this.stopMovingPoster();
  }

  onMouseup($event) {
    this.clickPositionDelta ={ x: Math.abs($event.pageX - this.clickStartPosition.x), y: Math.abs($event.pageY - this.clickStartPosition.y) };
    this.isPanning = false;
    this.CursorService.cursor = 'grab';
  }

  onPanStart($event) {
    if (this.NavigationService.isMobileMenuOpen) {
      return false;
    }
    this.stopWiggle();
    cancelAnimationFrame(this.panInertiaAnimationFrame);
    this.position.left += $event.deltaX - this.delta.x;
    this.position.top += $event.deltaY - this.delta.y;
    this.delta.x = $event.deltaX;
    this.delta.y = $event.deltaY;
    this.isPanning = true;
    this.loadImages();
    this.NavigationService.isTransparent = true;
  }

  openInternalUrl($event, url, params) {
    if (this.clickPositionDelta.x < 10 && this.clickPositionDelta.y < 10) {
      this.router.navigate([url], { queryParams: params });
      this.imageClick($event);
    }
  }

  openExternalUrl($event, url) {
    if (this.clickPositionDelta.x < 10 && this.clickPositionDelta.y < 10) {
      this.imageClick($event);
      window.open(url);
    }
  }

  imageClick($event) {
    if (this.isPanning) {
      $event.preventDefault();
    }
  }

  onPanMove($event) {
    if (this.NavigationService.isMobileMenuOpen) {
      return false;
    }
    this.position.left += $event.deltaX - this.delta.x;
    this.position.top += $event.deltaY - this.delta.y;
    this.delta.x = $event.deltaX;
    this.delta.y = $event.deltaY;

    this.loadImages();
  }

  onPanEnd($event) {
    this.panInertiaTimer = Date.now();
    let duration = 2000;
    // Hammer.js defines velocity as the change in 16ms
    let distance = {
      x: $event.velocityX * 0.625 * duration,
      y: $event.velocityY * 0.625 * duration
    };
    this.panInertiaStartPosition = clone(this.position);

    this.delta.x = 0;
    this.delta.y = 0;
    if (this.NavigationService.isMobileMenuOpen) {
      return false;
    }
    this.startPanInertia(distance, duration);
  }

  onPanCancel($event) {
    this.delta.x = 0;
    this.delta.y = 0;
    if (this.NavigationService.isMobileMenuOpen) {
      return false;
    }
    this.isPanning = false;
  }

  startPanInertia(distance, duration) {
    let time = Date.now() - this.panInertiaTimer,
      position = {
        top: penner.easeOutCirc(time, this.panInertiaStartPosition.top, distance.y, duration),
        left: penner.easeOutCirc(time, this.panInertiaStartPosition.left, distance.x, duration)
      };

    if (time > duration) {
      this.isPanning = false;
      cancelAnimationFrame(this.panInertiaAnimationFrame);
      return;
    }

    this.position.top = position.top;
    this.position.left = position.left;
    this.loadImages();

    this.panInertiaAnimationFrame = window.requestAnimationFrame(this.startPanInertia.bind(this, distance, duration));
  }

  stopPanInertia() {
    this.isPanning = false;
  }

  onMouseLeave($event) {
    this.stopMovingPoster();
  }

  onMouseMove($event) {
    let left = null;
    let top = null;
    let dx = null;
    let dy = null;

    let boundary = 125;

    if (this.NavigationService.isMobileMenuOpen || this.isPanning) {
      return false;
    }

    this.CursorService.cursor = 'move';

    let direction = null;
    let movePoster = false;
    let cY = 0;
    let cX = 0;

    // Mouse within boundary
    if (!($event.clientX > boundary && $event.clientX < window.innerWidth - boundary && 
     $event.clientY > boundary && $event.clientY < window.innerHeight - boundary)) {
      
      this.stopWiggle();
      this.NavigationService.isTransparent = true;

      // Mouse within left side
      if ($event.clientX <= boundary) {
        cX = 1;
        this.CursorService.cursor = 'arrowLeft';
      
      // Mouse within right side
      } else if ($event.clientX >= window.innerWidth - boundary) {
        cX = -1;
        this.CursorService.cursor = 'arrowRight';
      }

      // Mouse within top
      if ($event.clientY <= boundary) {
        cY = 1;

        if (this.CursorService.cursor === 'arrowLeft') {
          this.CursorService.cursor = 'arrowUpLeft';
        } else if (this.CursorService.cursor === 'arrowRight') {
          this.CursorService.cursor = 'arrowUpRight';
        } else {
          this.CursorService.cursor = 'arrowUp';
        }

      // Mouse within bottom
      } else if ($event.clientY >= window.innerHeight - boundary) {
        cY = -1;

        if (this.CursorService.cursor === 'arrowLeft') {
          this.CursorService.cursor = 'arrowDownLeft';
        } else if (this.CursorService.cursor === 'arrowRight') {
          this.CursorService.cursor = 'arrowDownRight';
        } else {
          this.CursorService.cursor = 'arrowDown';
        }
      }

      this.moveDirection = {
        x: cX,
        y: cY
      };

      if (!this.isMoving.x && cX !== 0) {
        this.startMovingPoster('x');
      } else if (cX === 0) {
        this.stopMovingPosterOnAxis('x');
      }

      if (!this.isMoving.y && cY !== 0) {
        this.startMovingPoster('y');
      } else if (cY === 0) {
        this.stopMovingPosterOnAxis('y');
      }

    } else {
      this.stopMovingPoster();
    }
  }

  stopMovingPoster() {
    this.stopMovingPosterOnAxis('x');
    this.stopMovingPosterOnAxis('y');
  }

  stopMovingPosterOnAxis(axis) {
    this.isMoving[axis] = false;
    cancelAnimationFrame(this.movePosterAnimationFrame[axis]);
  }

  startMovingPoster(axis) {
    this.isMoving[axis] = true;
    this.moveEasingPosterStartTime[axis] = null;
    this.moveEasingPosterStartPosition[axis] = null;
    this.moveLinearPosterStartTime[axis] = null;
    this.moveLinearPosterStartPosition[axis] = null;

    let previousPosition = axis === 'x' ? this.position.left : this.position.top;

    setTimeout(() => {
      this.animationFrame(axis, previousPosition, 0);
    }, 100);
  }

  // Each animation frame
  animationFrame(axis, previousPosition, previousElapsedTime) {
    let currentTime = Date.now();
    if (this.moveEasingPosterStartTime[axis] === null) {
      this.moveEasingPosterStartTime[axis] = currentTime;
      this.moveEasingPosterStartPosition[axis] = axis === 'x' ? this.position.left : this.position.top;
    }

    let elapsedAnimationTime = currentTime - this.moveEasingPosterStartTime[axis],
      easingDuration = 3700,
      position;

    // Still doing easing animation
    if (elapsedAnimationTime <= easingDuration) {
      let velocity = this.moveDirection[axis] * 0.1;
      let distance = velocity * easingDuration;
      position = penner.easeInQuad(elapsedAnimationTime, this.moveEasingPosterStartPosition[axis], distance, easingDuration);

    // Finished easing animation
    } else if (elapsedAnimationTime > easingDuration) {

      if (this.moveLinearPosterStartTime[axis] === null) {
        this.moveLinearPosterStartTime[axis] = currentTime;
        this.moveLinearPosterStartPosition[axis] = axis === 'x' ? this.position.left : this.position.top;
      }

      let elapsedLinearAnimationTime = currentTime - this.moveLinearPosterStartTime[axis];
      let linearDuration = 3600000;
      let distance = this.moveDirection[axis] * 0.17 * linearDuration;

      position = penner.linear(elapsedLinearAnimationTime, this.moveLinearPosterStartPosition[axis], distance, linearDuration);
    }

    var _previousPosition = axis === 'x' ? this.position.left : this.position.top

    if (axis === 'x')  {
      this.position.left = position;
    } else {
      this.position.top = position;
    }

    this.loadImages();

    this.movePosterAnimationFrame[axis] = window.requestAnimationFrame(this.animationFrame.bind(this, axis, _previousPosition, currentTime));
  }

  ngOnDestroy() {
    this.NavigationService.isTransparent = false;
    this.CursorService.cursor = null;
    this.stopWiggle();
    cancelAnimationFrame(this.panInertiaAnimationFrame);
    cancelAnimationFrame(this.movePosterAnimationFrame.x);
    cancelAnimationFrame(this.movePosterAnimationFrame.y);
    if (typeof this.breakpointSubscription !== 'undefined') {
      this.breakpointSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/poster/poster.component.ts